// extracted by mini-css-extract-plugin
export default {"submitButton":"_2KPNBFA19ZohIzmjfERhnE success expand large","heading":"_3L2xBMebRtWWhleS1VVKkn","subHeading":"_7foZCrKxq3QTkZAkwLzHUS","form":"rsD9xIvpFwMyUEQi7xHfg"};